import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dhats-title',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './title.component.html',
})
export class TitleComponent {
  level = input<1 | 2 | 3 | 4 | 5 | 6>(2);
  weight = input<'normal' | 'medium' | 'semibold' | 'bold'>('bold');
  
  baseClass = computed(() => {
    let sizeClass = '';
    switch (this.level()) {
      case 1: sizeClass = 'text-4xl lg:text-5xl tracking-tight'; break;
      case 2: sizeClass = 'text-3xl lg:text-4xl tracking-tight'; break;
      case 3: sizeClass = 'text-2xl lg:text-3xl tracking-tight'; break;
      case 4: sizeClass = 'text-xl lg:text-2xl'; break;
      case 5: sizeClass = 'text-lg lg:text-xl'; break;
      case 6: sizeClass = 'text-base lg:text-lg uppercase tracking-wider'; break;
    }
    
    return `${sizeClass} font-${this.weight()} text-color mb-4 leading-tight`;
  });
}
